import AboutIndex from './about-index';

export default class AboutIndexDesktop extends AboutIndex {
    constructor(...args) {
        super(...args);
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/about/about-index.desktop.js